import React from "react";
import { useNavigate } from "react-router";
import { NavLink } from "react-router-dom";

const Navbar = ()=>{
    const navigate = useNavigate()
    return (
        <nav className="navbar navbar-expand-lg bg-white fixed-top">
            <div className="container">
                <div className="d-flex">
                    <img src={require('../assets/logo.png')} className="img-fluid navbar-brand" />
                    <img src={require('../assets/oauife.png')} className="navbar-brand img-fluid" />
                </div>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                <ul className="navbar-nav ms-auto">
                    <li className="nav-item px-md-2">
                        <NavLink to={'/'} className="nav-link" aria-current="page" >Home</NavLink>
                    </li>
                    <li className="nav-item px-md-2">
                        <NavLink className="nav-link" to={'/about'}>About</NavLink>
                    </li>
                    <li className="nav-item px-md-2">
                        <NavLink className="nav-link" to={'/publications'}>Publications</NavLink>
                    </li>
                    <li className="nav-item px-md-2">
                        <NavLink className="nav-link" to={'/executives'} >Staff Advisers/Executives</NavLink>
                    </li>
                    <li className="nav-item px-md-2">
                        <NavLink className="nav-link" to={'/testimony'} >Testimonies</NavLink>
                    </li>
                    <li className="nav-item px-md-2">
                        <NavLink className="nav-link" to={'/contact'} >Contact</NavLink>
                    </li>
                </ul>
                </div>
            </div>
        </nav>
    )
}

export default Navbar